export const ENTRY_ANIMATION_MS=4000;
const key='marksimos-entry-start',maxAge=120000;
let memoryStart=null;
function browserStorage(){try{return window.sessionStorage;}catch{return undefined;}}
export function beginEntryTimeline({storage=browserStorage(),now=Date.now,restart=false}={}){
    const current=now();let stored;
    try{stored=storage?.getItem(key);}catch{ /* The in-memory timeline still works. */ }
    const candidate=restart?null:stored==null?memoryStart:Number(stored);
    const start=Number.isFinite(candidate)&&candidate<=current&&current-candidate<maxAge?candidate:current;
    memoryStart=start;
    try{storage?.setItem(key,String(start));}catch{ /* Storage may be disabled. */ }
    return start;
}
export const entryRemaining=(start,now=Date.now())=>Math.max(0,ENTRY_ANIMATION_MS-(now-start));
export function clearEntryTimeline({storage=browserStorage()}={}){
    memoryStart=null;
    try{storage?.removeItem(key);}catch{ /* Storage may be disabled. */ }
}
